import { DashboardSummeryErrorPayLoad, GetDashboardSummeryRequestPayload, GetDashboardSummerySuccessPayload } from "../interfaces/dashboardSummery"
import { Types } from "../types"
import { GetDashboardSummeryError, GetDashboardSummeryRequest, GetDashboardSummerySuccess } from "../types/dashboardSummery/actionType"


export const getDashboardSummeryRequestAction = (payload: GetDashboardSummeryRequestPayload): GetDashboardSummeryRequest => ({
    type: Types.GET_DASHBOARD_SUMMERY_REQUEST,
    payload
})

export const getDashboardSummerySuccessAction = (payload:GetDashboardSummerySuccessPayload):GetDashboardSummerySuccess  => ({
    type: Types.GET_DASHBOARD_SUMMERY_SUCCESS,
    payload
})

export const getDashboardSummeryErrorAction = (payload: DashboardSummeryErrorPayLoad): GetDashboardSummeryError => ({
    type: Types.GET_DASHBOARD_SUMMERY_ERROR,
    payload
})
